<template>
  <div class="sport-live-tv-event-grid">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-event-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 32px 24px;
  padding: 16px 0;

  @media (min-width: 700px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: $tablet) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
</style>
